<template>
    <div class="ssv-page-content__main">
        <main class="ssv-page-content__in">
            <div v-if="gift === false">
                <ssv-order-drywall-certification ref="order" v-if="type.code === 100"/>
                <ssv-order-add-hoc-certification ref="order" v-if="type.code === 300"/>
                <ssv-order-basic-drywall-training ref="order" v-if="type.code === 104"/>
                <ssv-order-drywall-new-trends ref="order" v-if="type.code === 105"/>
                <ssv-order-school-excursion ref="order" v-if="type.code === 301"/>
                <ssv-order-woodwork-certification ref="order" v-if="type.code === 200"/>
                <ssv-order-building-certification ref="order" v-if="type.code === 302"/>
                <ssv-order-drywall-certification-store ref="order" v-if="type.code === 102"/>
                <ssv-order-drywall-individual-certification ref="order" v-if="type.code === 101"/>
                <ssv-order-basic-drywall-training ref="order" v-if="type.code === 103"/>
                <ssv-order-online-certification ref="order" v-if="type.code === 400"/>
                <ssv-order-online-woodwork-certification ref="order" v-if="type.code === 401"/>
                <ssv-order-certificate-copy ref="order" v-if="type.code === 303"/>
                <ssv-order-vks ref="order" v-if="type.code === 500"/>
                <ssv-order-distributor ref="order" v-if="type.code === 600"/>
            </div>
            <ssv-order-gift-card ref="order" v-if="gift"/>
            <p class="ssv-form--personal-data">
                Odesláním souhlasíte se <a target="_blank" href="/ochrana-osobnich-udaju">zpracováním osobních údajů</a>
                za účelem vyřízení objednávky.
            </p>
            <button type="button" class="button button--primary" v-on:click="submitOrder()">
                {{ctaLabel}}
            </button>
            <ssv-order-error-state message="Objednávku se nepodařilo vytvořit, zkuste to, prosím, znovu." v-if="error"/>
        </main>
        <aside class="ssv-page-content__aside">
            <img src="/wp-content/themes/rigips/images/v3/banners/vks.png" v-if="type.code === 500">
            <img src="/wp-content/themes/rigips/images/ssv-1.png" v-else>
        </aside>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import SsvOrderErrorState from '../error/ErrorState';
import SsvOrderDrywallCertification from './DrywallCertification';
import SsvOrderAddHocCertification from './AddHocCertification';
import SsvOrderDrywallNewTrends from './DrywallNewTrends';
import SsvOrderWoodworkCertification from './WoodworkCertification';
import SsvOrderGiftCard from './GiftCard';
import SsvOrderDrywallCertificationStore from './DrywallCertificationStore';
import SsvOrderDrywallIndividualCertification from './DrywallIndividualCertification';
import SsvOrderBasicDrywallTraining from './BasicDrywallTraining';
import SsvOrderSchoolExcursion from './SchoolExcursion';
import SsvOrderBuildingCertification from './BuildingCertification';
import SsvOrderOnlineCertification from './OnlineCertification';
import SsvOrderCertificateCopy from './CertificateCopy';
import SsvOrderVks from './Vks';
import SsvOrderOnlineWoodworkCertification from './OnlineWoodworkCertification';
import SsvOrderDistributor from './Distributor';

export default {
    name:       'SsvOrderContainer',
    components: {
        SsvOrderDistributor,
        SsvOrderOnlineWoodworkCertification,
        SsvOrderVks,
        SsvOrderOnlineCertification,
        SsvOrderBuildingCertification,
        SsvOrderSchoolExcursion,
        SsvOrderBasicDrywallTraining,
        SsvOrderDrywallIndividualCertification,
        SsvOrderDrywallCertificationStore,
        SsvOrderGiftCard,
        SsvOrderWoodworkCertification,
        SsvOrderDrywallNewTrends,
        SsvOrderAddHocCertification,
        SsvOrderDrywallCertification,
        SsvOrderCertificateCopy,
        SsvOrderErrorState,
    },
    data() {
        return {
            processing: false,
            error:      false,
        }
    },
    computed:   {
        ...mapGetters('ssvOrder', ['type', 'gift', 'errors']),
        ctaLabel() {
            if (this.type.code === 500) return this.processing ? 'Odesílám objednávku...' : 'Odeslat objednávku';
            return this.processing ? 'Odesílám přihlášku...' : 'Odeslat přihlášku';
        }
    },
    methods:    {
        ...mapActions('ssvOrder', ['clearErrors', 'createOrder']),
        submitOrder() {
            this.isValidate();
            if (this.errors.length === 0) {
                if (this.processing) return;
                this.processing = true;
                this.error = false;
                this.createOrder()
                .then(() => this.$router.push({ name: 'ssv.order.thank' }))
                .catch(() => this.error = true)
                .finally(() => this.processing = false);
            } else {
                setTimeout(() => {
                    const firstError = document.querySelector('.js-error');
                    if (firstError) {
                        const offset = 45;
                        const bodyRect = document.body.getBoundingClientRect().top;
                        const elementRect = firstError.getBoundingClientRect().top;
                        const elementPosition = elementRect - bodyRect;
                        const offsetPosition = elementPosition - offset;

                        window.scrollTo({
                            top:      offsetPosition,
                            behavior: 'smooth'
                        });
                    }
                }, 100);
            }
        },
        isValidate() {
            this.clearErrors();
            this.$refs.order.validate();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/order/OrderContainer.vue